import { render, staticRenderFns } from "./Abandon.vue?vue&type=template&id=83f0b3d0&scoped=true"
import script from "./Abandon.vue?vue&type=script&lang=ts"
export * from "./Abandon.vue?vue&type=script&lang=ts"
import style0 from "./Abandon.vue?vue&type=style&index=0&id=83f0b3d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f0b3d0",
  null
  
)

export default component.exports